export default {
    afterInit: function(component){
        if(component.$route.name=='home'){
            // component.enableSubmit = false;
            var questionMap = component.questionMap;
            console.log('logic loaded',{
                questionMap: questionMap
            })
            var hideThese = [1,2,3,4,5,6,7,8,9,10,11,12,13,19,20,21];
            for(let i=0; i<hideThese.length; i++){
                var qid = hideThese[i];
                var question = questionMap[qid];
                document.getElementById('sid_8_qid_'+question.config.id).style.display='none';
            }

            setTimeout(function(){
                var questionMap = component.questionMap;
                console.log('reapply logic',{
                    questionMap: questionMap
                })
                var hideThese = [1,2,3,4,5,6,7,8,9,10,11,12,13,19,20,21];
                for(let i=0; i<hideThese.length; i++){
                    var qid = hideThese[i];
                    var question = questionMap[qid];
                    document.getElementById('sid_8_qid_'+question.config.id).style.display='none';
                }                
            },1000)
        }
    }
}